__turbopack_context__.v({
  "are_centered": "styles-module-scss-module__B4Bloa__are_centered",
  "are_vertical": "styles-module-scss-module__B4Bloa__are_vertical",
  "checkboxes_container": "styles-module-scss-module__B4Bloa__checkboxes_container",
  "header": "styles-module-scss-module__B4Bloa__header",
  "icon_container": "styles-module-scss-module__B4Bloa__icon_container",
  "label_text": "styles-module-scss-module__B4Bloa__label_text",
  "radio_button": "styles-module-scss-module__B4Bloa__radio_button",
  "radio_buttons": "styles-module-scss-module__B4Bloa__radio_buttons",
  "with_icon": "styles-module-scss-module__B4Bloa__with_icon",
  "with_label": "styles-module-scss-module__B4Bloa__with_label",
  "with_label_inside": "styles-module-scss-module__B4Bloa__with_label_inside",
  "with_label_inside_square": "styles-module-scss-module__B4Bloa__with_label_inside_square",
});
